import React from 'react';

const createTextElement = (text: string, key?: string | number) => {
	// TODO: something in the vtt parser is messeing up things `&lt;Laugh&gt;.` and we get `<;Laugh>;`
	// before ever getting here for dsiplay, so we need to clean it up for now
	return <span key={key}>{text.replace(/\<;(.*)>;/g, '<$1>').trim()}</span>;
};

const createLineBreakElement = (key?: string | number) => {
	return <br key={key} />;
};

// TODO: test / cleanup
export const newlineStringToElements = (str: string, key?: string | number) => {
	if (str === '\n' || str === '\\n') return [createLineBreakElement(key)];

	const pieces = str.split(/\\n|\\\\n/);

	if (pieces.length === 1) return [createTextElement(pieces[0], key)];

	let firstItemWasNewLine = false;
	return pieces.map((item, index) => {
		if (index === 0) {
			if (item === '') {
				firstItemWasNewLine = true;
				return createLineBreakElement(index);
			}
			return createTextElement(item, index);
		}
		return firstItemWasNewLine && index === 1
			? createTextElement(item, `span-${index}`)
			: [
					createLineBreakElement(index),
					createTextElement(item, `span-${index}`),
			  ];
	});
};
